import React, { ReactNode } from 'react';
import { CardDelete as Card } from '../../../../../../components/Lists';
import { LineBeingDeletedType } from '../../../types';

interface CardDeleteInterface {
  lineBeingDeleted: LineBeingDeletedType;
  directionTagLiterals: { [key: number]: ReactNode };
}

export default function CardDelete({
  lineBeingDeleted,
  directionTagLiterals,
}: CardDeleteInterface) {
  return (
    <Card>
      <div className="info">
        <div className="card-title">
          <strong>{lineBeingDeleted.lineCode}</strong>
          {lineBeingDeleted.direction && (
            directionTagLiterals[lineBeingDeleted.direction]
          )}
        </div>
        <span>{lineBeingDeleted.lineSign?.replace('.kml', '')}</span>
        <span>
          {lineBeingDeleted.departureTime}
          -
          {lineBeingDeleted.arrivalTime}
        </span>
        <span>
          {lineBeingDeleted.capacity}
          {' '}
          lugares
        </span>
        <span>
          {lineBeingDeleted.workplaceDescription}
        </span>
      </div>
    </Card>
  );
}
